export const mapUsersOptions = (users = []) => {
  return users.map(el => {
    return {
      ...el,
      name: el?.first_name ?? el?.email,
    };
  }) ?? [];
};

export const formatDate = (date, time) => {
  const dateObj = new Date(date);
  const timeObj = new Date(time);
  const hours = timeObj.getHours();
  const minutes = timeObj.getMinutes();
  const seconds = timeObj.getSeconds();
  return new Date(dateObj.setHours(hours, minutes, seconds));
};
